import React, { useEffect, useState } from "react";

import RenderStringHtml from "shared/components/atoms/RenderStringHtml";
import {
  formatBrazilianCurrency,
  formatPrice,
} from "shared/utils/formatBrazilianCurrency";

import {
  IInstallment,
  IOrderBumpCheckout,
} from "@CheckoutStepsOffers/@types/offer";
import {
  getInstallmentOptions,
  getInstallmentsOrderBump,
} from "@CheckoutStepsOffers/utils/getInstallments";
import Select, {
  IOptionsProps,
} from "@payment/components/molecules/OrderBumpCTA/components/Select";
import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";

import CheckboxStyled from "./components/CheckboxStyled";
import {
  BeforePrice,
  BeforePriceSpan,
  Description,
  LabelDescription,
  OrderBumpCTAContainer,
  OrderBumpCTAContent,
  OrderBumpCTAHeader,
  Price,
  ProductColorGroup,
  ProductContainer,
  ProductImage,
  SubTitle,
  Title,
  WrapperDescription,
  WrapperOrderBumpCTA,
  WrapperSelect,
  WrapperText,
} from "./styles";

interface IOrderBumpCTA {
  orderBump: IOrderBumpCheckout;
  paymentMethodSelected: string;
  handleSelectOrderBump?: () => void;
  onSelectInstallments?: (
    option: IOptionsProps,
    installment: IInstallment,
  ) => void;
}

const OrderBumpCTA = ({
  orderBump,
  paymentMethodSelected,
  onSelectInstallments,
  handleSelectOrderBump,
}: IOrderBumpCTA) => {
  const groupImage = orderBump?.group?.logo_horizontal;
  const groupColor = orderBump?.group?.primary_color;

  const installments = getInstallmentsOrderBump(orderBump);
  const installmentsOptions = getInstallmentOptions(installments);

  const { country } = useCheckoutContext();

  const [installmentSelected, setInstallmentSelected] = useState<IOptionsProps>(
    installmentsOptions[0],
  );
  const handleSelect = () => {
    handleSelectOrderBump();

    const [installment] = installments?.filter(
      (installment) =>
        String(installment?.installment) === installmentSelected?.value,
    );

    onSelectInstallments(installmentSelected, installment);
  };

  useEffect(() => {
    if (country !== "Brasil") {
      setInstallmentSelected(installmentsOptions[0]);
    }
  }, [country]);

  return (
    <OrderBumpCTAContainer>
      <OrderBumpCTAHeader>
        <CheckboxStyled
          name="add_orderBump"
          onClick={handleSelect}
          label={orderBump?.cta_text}
          price={
            installmentSelected.value === "1" || country !== "Brasil"
              ? formatBrazilianCurrency(formatPrice(orderBump?.price))
              : installmentSelected.text
          }
        />
      </OrderBumpCTAHeader>

      <OrderBumpCTAContent>
        <ProductContainer>
          {groupImage ? (
            <ProductImage alt="product image" src={groupImage} />
          ) : (
            <ProductColorGroup color={groupColor} />
          )}

          <WrapperText>
            <Title>{orderBump?.group?.title}</Title>

            <BeforePrice>
              {Number(orderBump?.before_price) > 0 && (
                <BeforePriceSpan>
                  de{" "}
                  <s>
                    {formatBrazilianCurrency(
                      formatPrice(orderBump?.before_price),
                    )}{" "}
                  </s>
                  por
                </BeforePriceSpan>
              )}
              <Price>
                {" "}
                {formatBrazilianCurrency(formatPrice(orderBump?.price))}
              </Price>
            </BeforePrice>
          </WrapperText>
        </ProductContainer>

        <WrapperDescription>
          {orderBump?.offer_name && (
            <SubTitle>{orderBump?.offer_name}</SubTitle>
          )}

          {orderBump?.description && (
            <Description>
              <RenderStringHtml value={orderBump?.description} />
            </Description>
          )}
        </WrapperDescription>

        {paymentMethodSelected !== "pix" &&
          paymentMethodSelected !== "boleto" && (
            <>
              {installments?.length > 1 && country === "Brasil" && (
                <WrapperSelect>
                  <LabelDescription>
                    Selecione o número de parcelas
                  </LabelDescription>

                  <Select
                    name="installments"
                    placeholder="10 parcelas"
                    defaultValue={installmentSelected?.value}
                    options={installmentsOptions}
                    onChangeCustom={(option) => {
                      if (onSelectInstallments) {
                        const [installment] = installments?.filter(
                          (installment) =>
                            String(installment?.installment) === option?.value,
                        );

                        onSelectInstallments(option, installment);
                        setInstallmentSelected(option);
                      }
                    }}
                  />
                </WrapperSelect>
              )}
            </>
          )}
      </OrderBumpCTAContent>
    </OrderBumpCTAContainer>
  );
};

export { WrapperOrderBumpCTA };
export default OrderBumpCTA;
